import { z } from 'zod'
import { Model } from '../../_kernel/architecture'
import { Fee } from './Fee'
import type { ListOfAvailabilityReduxLegacyType } from './ListOfAvailabilityReduxLegacySchema'
import { Money } from '../../_kernel/Money'

export const ListOfFeeValidation = z.object({
  list: z.instanceof(Fee, { message: '[ListOfFee] list is required' }).array(),
})

export class ListOfFee extends Model {
  static create({ list }: z.infer<typeof ListOfFeeValidation>) {
    ListOfFeeValidation.parse({ list })
    return new ListOfFee(list)
  }

  static fromJSON({ json }: { json: ReturnType<ListOfFee['toJSON']> }) {
    return ListOfFee.create({
      list: json.list.map(fee => Fee.fromJSON(fee)),
    })
  }

  static fromAvailabilityBoardRedux({ board }: { board: ListOfAvailabilityReduxLegacyType }) {
    return ListOfFee.create({
      list:
        board.additionalFees?.map(fee =>
          Fee.fromJSON({
            total: Money.fromJSON({ amount: fee.amount, currency: fee.currency }),
            local: fee.local ? Money.fromJSON(fee.local) : undefined,
          })
        ) ?? [],
    })
  }

  constructor(readonly list: Fee[]) {
    super()
  }

  toJSON() {
    return { list: this.list.map(item => item.toJSON()) }
  }

  map<T>(callback: (fee: Fee, index: number) => T) {
    return this.list.map(callback)
  }
}
